import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['eventInfoWrapper', 'eventFormWrapper']

  static values = {
    alertMessages: Object
  }

  connect() {
  }

  continueToForm() {
    this.eventFormWrapperTarget.classList.remove('d-none')
    this.eventInfoWrapperTarget.classList.add('d-none')
  }
} 